// extracted by css-extract-rspack-plugin
export default {"menuSelector":"profile-menu-module__menuSelector___ugMHt","chevron":"profile-menu-module__chevron___CEjYi","avatar":"profile-menu-module__avatar___KYpUN"};